/*
  `icon` é um elemento React, não o nome de um ícone. Era uma string com o
  nome da ligadura do Material Icons (`<EmptyTable icon="local_offer">`), o
  que obrigava o painel a carregar @mui/material e a fonte Material Icons
  inteira para desenhar um ícone — em duas telas. Agora quem chama passa o
  ícone do react-icons, que já é a biblioteca de ícones de todo o resto.
*/
const EmptyTable = ({ icon, children }) => {
  return (
    <div className="border-dashed py-10 px-4 border-2 border-gray-300 rounded-md text-center flex-col flex items-center mb-6 mt-6">
      <span className="color-primary text-2xl">{icon}</span>
      <span className="text-sm">
        {children}
      </span>
    </div>
  );
};

export default EmptyTable;
